import React, { useMemo } from 'react'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import AccommodationPackageInclusionsList from '../Accommodation/AccommodationPackageInclusionsList'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  bonusInclusions?: Array<App.PackageInclusion>;
  inclusions?: Array<App.PackageInclusion>;
  /**
   * @default medium
   */
  size?: 'small' | 'medium' | 'large';
}

function InclusionsSection(props: Props) {
  const {
    bonusInclusions = EmptyArray,
    inclusions = EmptyArray,
    size = 'medium',
  } = props

  const inclusionContent = useMemo(() => inclusions.map(incl => incl.description).join('\n'), [inclusions])
  const bonusInclusionContent = useMemo(() => bonusInclusions.map(incl => incl.description).join('\n'), [bonusInclusions])
  const hasBonusInclusions = bonusInclusions.length > 0

  return <VerticalSpacer gap={12}>
    {hasBonusInclusions && <AccommodationPackageInclusionsList title="bonus">
      <MarkdownRender fontSize={size} type="compact" content={bonusInclusionContent} />
    </AccommodationPackageInclusionsList>}
    {inclusions.length > 0 && <AccommodationPackageInclusionsList title={hasBonusInclusions ? 'additional' : undefined}>
      <MarkdownRender fontSize={size} type="compact" content={inclusionContent} />
    </AccommodationPackageInclusionsList>}
  </VerticalSpacer>
}

export default InclusionsSection
